import { useState } from "react";
import { LuMapPin } from "react-icons/lu";
import { FaFacebook, FaInstagram, FaTiktok, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { RiContactsBook3Line } from "react-icons/ri";

export default function Map() {
    const [location, setLocation] = useState("pusat");

    const locations: any = {
        pusat: {
            mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.304870389595!2d119.8819557759016!3d-0.919210099071899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2d8bf1fdea4dbd8b%3A0xd9f597b1aefc25ba!2sBank%20BPR%20Palu%20Anugerah!5e0!3m2!1sid!2sid!4v1731570378356!5m2!1sid!2sid",
            address: "Jl. Jenderal Basuki Rahmat No. 86, Birobuli Utara, Palu Selatan, Tatura Sel., Kec. Palu Sel., Kota Palu, Sulawesi Tengah 94111",
            phone: "0895-4060-15202",
            email: "bprpaluanugerah@gmail.com",
            socialLinks: {
                facebook: "https://www.facebook.com/Bprpaluanugerah01",
                instagram: "https://www.instagram.com/bprpaluanugerah/",
                tiktok: "https://www.tiktok.com/@bprpaluanugerah",
                whatsapp: "https://wa.me/62895406015202"
            }
        },
        poso: {
            mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d255296.75133244647!2d120.15663874625767!3d-1.1521056849806373!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2d8ee5a9d4d97d73%3A0x93e88a97799d90fd!2sPT%20Bank%20Perkreditan%20Rakyat%20(BPR)%20Palu%20Anugerah%20Cabang%20Poso!5e0!3m2!1sid!2sid!4v1731571107148!5m2!1sid!2sid",
            address: "Jl. Yos Sudarso No 3 Kel, Kasintuwu",
            phone: "0452-325388",
            email: "-",
            socialLinks: {
                facebook: "https://www.facebook.com/people/Bpr-Palu-Anugerah-Poso",
                instagram: "https://www.instagram.com/pt_bpr_paluanugerahposo/",
                tiktok: "#"
            }
        },
        luwuk: {
            mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2042555.991260657!2d118.7081178659509!3d-0.8616395021986455!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2d86a15e4c6c9e45%3A0x771538091229d495!2sPt.%20Bank%20Perkreditan%20Rakyat%20Palu%20Anugerah!5e0!3m2!1sid!2sid!4v1731571285570!5m2!1sid!2sid",
            address: "Jl. D.I Panjaitan No 8 Luwuk Banggai",
            phone: "0461-23981",
            email: "-",
            socialLinks: {
                facebook: "https://www.facebook.com/paluanugerah.luwuk.9",
                instagram: "https://www.instagram.com/paluanugerahluwuk/",
                tiktok: "#"
            }
        },
        parigi: {
            mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d127659.7417671582!2d119.94509688445218!3d-0.8618688588190029!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2d895f9a60625ef7%3A0x4b1548409dc8caf5!2sBPR%20PALU%20ANUGERAH%20CAB%20PARIGI!5e0!3m2!1sid!2sid!4v1731571215510!5m2!1sid!2sid",
            address: "Jl. Parigi Sejahtera No. 9, Parigi",
            phone: "0450-22446",
            email: "-",
            socialLinks: {
                facebook: "https://facebook.com/palu",
                instagram: "https://instagram.com/palu",
                tiktok: "#"
            }
        },
    };

    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-60 p-5 md:p-5 lg:p-16" id="contact">
            <h1 className="text-2xl font-poppinsBold text-bprDarkBlue text-center">KONTAK KAMI</h1>
            <div className="mt-5 flex flex-wrap justify-center gap-5">
                {[
                    { label: 'Pusat', value: 'pusat' },
                    { label: 'Poso', value: 'poso' },
                    { label: 'Luwuk', value: 'luwuk' },
                    { label: 'Parigi', value: 'parigi' },
                ].map((locationOption) => (
                    <button
                        key={locationOption.value}
                        className={`py-3 px-5 rounded ${location === locationOption.value ? 'bg-bprDarkBlue text-white' : 'bg-white text-bprDarkBlue border border-bprDarkBlue'}`}
                        onClick={() => setLocation(locationOption.value)}
                    >
                        {locationOption.label}
                    </button>
                ))}
            </div>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="border p-4 rounded shadow-lg text-center">
                    <LuMapPin className="text-bprDarkBlue text-4xl mx-auto mb-3" />
                    <h2 className="text-lg font-semibold">Alamat</h2>
                    <p>{locations[location].address}</p>
                </div>
                <div className="border p-4 rounded shadow-lg text-center">
                    <RiContactsBook3Line className="text-bprDarkBlue text-4xl mx-auto mb-3" />
                    <h2 className="text-lg font-semibold">Kontak</h2>
                    <p>Telepon: {locations[location].phone}</p>
                    <p>Email: {locations[location].email}</p>
                </div>
                <div className="border p-4 rounded shadow-lg text-center">
                    <h2 className="text-lg font-semibold">Media Sosial</h2>
                    <div className="flex justify-center gap-4 mt-2">
                        <a href={locations[location].socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                            <FaFacebook className="text-bprDarkBlue text-2xl" />
                        </a>
                        <a href={locations[location].socialLinks.instagram} target="_blank" rel="noopener noreferrer">
                            <FaInstagram className="text-bprDarkBlue text-2xl" />
                        </a>
                        <a href={locations[location].socialLinks.tiktok} target="_blank" rel="noopener noreferrer">
                            <FaTiktok className="text-bprDarkBlue text-2xl" />
                        </a>
                        {locations[location].socialLinks.whatsapp && (
                            <a href={locations[location].socialLinks.whatsapp} target="_blank" rel="noopener noreferrer">
                                <FaWhatsapp className="text-bprDarkBlue text-2xl" />
                            </a>
                        )}
                    </div>
                </div>
            </div>

            {/* Iframe Peta */}
            <iframe
                className="mt-10 w-full h-96"
                src={locations[location].mapUrl}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </div>
    );
}
